/** MIME types the profile editor accepts for the profile picture. */
export const ALLOWED_PROFILE_IMAGE_MIME_TYPES = [
  'image/png',
  'image/jpeg',
  'image/webp',
];

/** `accept` of the hidden file input; mirrors the MIME list above. */
export const PROFILE_IMAGE_ACCEPT = 'image/png,image/jpeg,image/webp';

/**
 * Tells whether a picked file is an image the profile can carry.
 *
 * `accept` on the input is a filter, not a guard — the picker's "All Files"
 * option walks straight past it and a drop carries whatever was dragged, so
 * every file reaches this check. Mirrors the assistant-icon check: some
 * browsers report an empty MIME type for a dropped file, so the extension is
 * accepted as a fallback.
 *
 * @param file - File picked in the input or dropped on the avatar.
 * @returns Whether the file may be uploaded.
 */
export const isAllowedProfileImageFile = (file: File): boolean => {
  const mimeOk =
    !!file.type && ALLOWED_PROFILE_IMAGE_MIME_TYPES.includes(file.type);
  const nameOk = /\.(png|jpe?g|webp)$/i.test((file.name ?? '').trim());

  return mimeOk || nameOk;
};
